import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

import { ApplicationPaymentApiService } from '../index';
import { IApplicationPayment, IApplicationPaymentInput } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import { 
  GetApplicationPaymentByIdQuery,
  SaveApplicationPaymentMutation
} from '@ebb-v2/ebb-integration';

@Injectable({
    providedIn: 'root'
  })
  export class ApplicationPaymentGqlService implements ApplicationPaymentApiService {

    constructor(
      private apollo: Apollo
    ) { }
  
    public getApplicationPayment(applicationId: string): Observable<IApplicationPayment> {
      //console.log(`ApplicationPaymentGql.getApplicationPayment()`);
      return this.apollo
        .query({
          query: GetApplicationPaymentByIdQuery,
          variables: {
            applicationId: applicationId
          },
          fetchPolicy: 'network-only'
        })
        .pipe(
            map(result => result.data['applicationPayment'] as IApplicationPayment | null)
        );
    }

    public updateApplicationPayment(applicationPayment: IApplicationPaymentInput, applicationPaymentId: string | ''): Observable<any> {
      //console.log(`ApplicationPaymentApi.updateApplication()`);
      return this.apollo
        .mutate({
          mutation: SaveApplicationPaymentMutation,
          variables : {
            applicationPayment,
            applicationPaymentId
          }
        })
        .pipe(map(result => result.data['saveApplicationPayment'].id as string));
    }

  }